import { composeTelemetry } from './services';
export function emitGlobalSetTelemetry(updatedSettings, context, filespaceClient) {
    if (!filespaceClient) {
        return;
    }
    for (const event of composeTelemetry(updatedSettings, context)) {
        filespaceClient.logFilespaceEvent(event);
    }
}
export async function emitGlobalUnsetTelemetry(settings, context, filespaceClient) {
    if (!filespaceClient) {
        return;
    }
    const updatedSettings = await filespaceClient
        .globalSettingManager()
        .get(settings);
    for (const event of composeTelemetry(updatedSettings, context)) {
        filespaceClient.logFilespaceEvent(event);
    }
}
